import { pushAPI } from '../services/api';

const isSupported =
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window;

// Backed by a plain ArrayBuffer, not the generic ArrayBufferLike `Uint8Array.from`
// infers: PushManager.subscribe takes a BufferSource, which excludes SharedArrayBuffer.
function urlBase64ToUint8Array(base64String: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const bytes = new Uint8Array(new ArrayBuffer(rawData.length));

  for (let i = 0; i < rawData.length; i += 1) {
    bytes[i] = rawData.charCodeAt(i);
  }

  return bytes;
}

export function usePushNotifications() {
  const registerPush = async () => {
    if (!isSupported) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      const vapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY as string;
      if (!vapidKey) {
        console.warn('VITE_VAPID_PUBLIC_KEY is not set');
        return;
      }
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    const { endpoint, keys } = subscription.toJSON() as {
      endpoint: string;
      keys: { p256dh: string; auth: string };
    };

    await pushAPI.subscribe({ endpoint, keys });
  };

  return { registerPush, isSupported };
}
